module.exports = __webpack_public_path__ + "static/media/naira-sign.52ac344e.png";